import { PropsWithChildren } from 'react';
import modalStyles from './modal.module.scss';

type DevToolsModalProps = { isOpen: boolean; onClose: () => void; title: string };

export const DevToolsModal = ({
  isOpen,
  onClose,
  title,
  children
}: PropsWithChildren<DevToolsModalProps>) => {
  if (!isOpen) return null;
  return (
    <dialog
      open
      aria-modal='true'
      aria-labelledby='dialog-title'
      className={modalStyles.modalDialog}
    >
      <div className={modalStyles.modalDialogHeader}>
        <h2 id='dialog-title'>{title}</h2>
        <button onClick={onClose}>Close</button>
      </div>
      <div>{children}</div>
    </dialog>
  );
};
